import * as React from 'react';
import styled from 'styled-components';
import { MenuContext } from '.';

export const NavIcon = () => {
  const context = React.useContext(MenuContext);

  const navIconOpen =
    context.menuState.modalVisible || context.menuState.searchVisible;

  const clickMenu = (e: any) => {
    e.preventDefault();

    // Dersom søket ikke er synlig fungerer denne som en meny toggle
    if (!context.menuState.searchVisible) {
      context.setMenuState({
        ...context.menuState,
        modalVisible: !context.menuState.modalVisible,
        searchVisible: false,
      });
    }
    // Dersom søket er synlig og menyen ikke er synlig så fungerer denne som en lukk-knapp
    if (!context.menuState.modalVisible && context.menuState.searchVisible) {
      context.setMenuState({
        ...context.menuState,
        modalVisible: false,
        searchVisible: !context.menuState.searchVisible,
      });
    }
    // Dersom begge to er synlige
    if (context.menuState.modalVisible && context.menuState.searchVisible) {
      context.setMenuState({
        ...context.menuState,
        modalVisible: false,
        searchVisible: false,
      });
    }
  };

  return (
    <HamburgerWrapper>
      <Hamburger onClick={clickMenu} className={navIconOpen ? 'open' : ''}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </Hamburger>
    </HamburgerWrapper>
  );
};

const Hamburger = styled.a`
  display: block;
  width: 25px;
  height: 18px;
  position: absolute;
  margin: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #fff;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
  }

  /* Icon 3 */

  span:nth-child(1) {
    top: 0px;
  }

  span:nth-child(2),
  span:nth-child(3) {
    top: 7px;
  }

  span:nth-child(4) {
    top: 14px;
  }

  &.open span:nth-child(1) {
    top: 14px;
    width: 0%;
    left: 50%;
  }

  &.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  &.open span:nth-child(4) {
    top: 14px;
    width: 0%;
    left: 50%;
  }
`;

const HamburgerWrapper = styled.div`
  display: block;
  position: relative;
  width: 25px;
  height: 23px;

  /*   @media (min-width: 1140px) {
    display: none;
  } */
`;
